import { Col } from "antd";
import { SelectProdutorMultiple } from "components/select/SelectProdutorMultiple";
import { SelectTransportadorMultiple } from "components/select/SelectTransportadorMultiple";
import { FormItemNoMargin } from "pages/relatorios/components/FormItemNoMargin";
import { useRelatorioStore } from "pages/relatorios/store";
import { useMemo } from "react";

type RelatorioFilterProdutorTransportadorProps = {
	showProdutor?: boolean;
	showTransportador?: boolean;
};

export function RelatorioFilterProdutorCol() {
	const filterProdutores = useRelatorioStore((s) => s.filter?.filterProdutores);

	const produtorIds = useMemo(() => produtorIdsFromList(filterProdutores), [filterProdutores]);

	return (
		<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
			<FormItemNoMargin label="Produtor">
				<SelectProdutorMultiple
					value={produtorIds}
					selectedProdutores={filterProdutores ?? []}
					onChange={(_, produtores) => {
						useRelatorioStore.setState((state) => ({
							filter: {
								...state.filter,
								filterProdutores: produtores,
							},
						}));
					}}
				/>
			</FormItemNoMargin>
		</Col>
	);
}

export function RelatorioFilterTransportadorCol() {
	const filterTransportadores = useRelatorioStore((s) => s.filter?.filterTransportadores);

	const transportadorIds = useMemo(() => transportadorIdsFromList(filterTransportadores), [filterTransportadores]);

	return (
		<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
			<FormItemNoMargin label="Transportador">
				<SelectTransportadorMultiple
					value={transportadorIds}
					selectedTransportadores={filterTransportadores ?? []}
					onChange={(_, transportadores) => {
						useRelatorioStore.setState((state) => ({
							filter: {
								...state.filter,
								filterTransportadores: transportadores,
							},
						}));
					}}
				/>
			</FormItemNoMargin>
		</Col>
	);
}

function produtorIdsFromList(produtores: { for_idpk: number }[] | undefined): number[] {
	return produtores?.map((produtor) => produtor.for_idpk) ?? [];
}

function transportadorIdsFromList(transportadores: { tra_idpk: number }[] | undefined): number[] {
	return transportadores?.map((transportador) => transportador.tra_idpk) ?? [];
}

export function RelatorioFilterProdutorTransportador({
	showProdutor = true,
	showTransportador = true,
}: RelatorioFilterProdutorTransportadorProps) {
	return (
		<>
			{showProdutor ? <RelatorioFilterProdutorCol /> : null}
			{showTransportador ? <RelatorioFilterTransportadorCol /> : null}
		</>
	);
}
